import {
  OPT_TASKS_LIST_STATUS_ALL,
  OPT_TASKS_LIST_STATUS_ALL_VALUE,
  OPT_TASKS_LIST_STATUS_DISABLED,
  OPT_TASKS_LIST_STATUS_DISABLED_VALUE,
  OPT_TASKS_LIST_STATUS_ENABLED,
  OPT_TASKS_LIST_STATUS_ENABLED_VALUE
} from 'Constants/'
import { Select } from 'mailup-web-components'
import { searchState } from 'Pages/TasksList/recoil/state/search'
import PropTypes from 'prop-types'
import { useRef } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

export const InputStatus = ({ onChange }) => {
  const intl = useIntl()
  const [{ isEnabled }, setSearchParams] = useRecoilState(searchState)

  const { current: options } = useRef([
    {
      label: intl.formatMessage({ id: OPT_TASKS_LIST_STATUS_ALL }),
      value: OPT_TASKS_LIST_STATUS_ALL_VALUE
    },
    {
      label: intl.formatMessage({ id: OPT_TASKS_LIST_STATUS_ENABLED }),
      value: OPT_TASKS_LIST_STATUS_ENABLED_VALUE
    },
    {
      label: intl.formatMessage({ id: OPT_TASKS_LIST_STATUS_DISABLED }),
      value: OPT_TASKS_LIST_STATUS_DISABLED_VALUE
    }
  ])

  const handleInputChange = (e) => {
    const val = e
    setSearchParams((prev) => ({
      ...prev,
      isEnabled: val
    }))
  }

  return (
    <Select
      searchable={false}
      options={options}
      onChange={handleInputChange}
      value={isEnabled}
    />
  )
}

InputStatus.propTypes = {
  onChange: PropTypes.func
}
